import React, {useEffect, useState} from "react";
import SectionCategory from "@/components/Faq/SectionCategory";
import {Section} from "@/interface/FAQ";
import {Carousel, CarouselContent, CarouselItem} from "@/components/ui/carousel";

interface FAQSectionProps {
    sections: Section[];
}

const FAQSection: React.FC<FAQSectionProps> = ({ sections }) => {
    const [totalPerRow, setTotalPerRow] = useState(4);

    useEffect(() => {
        const updateTotalPerRow = () => {
            if (window.innerWidth >= 1024) {
                setTotalPerRow(4);  // 4 colonne per schermi grandi
            } else if (window.innerWidth >= 768) {
                setTotalPerRow(3);  // 3 colonne per schermi medi
            } else if (window.innerWidth >= 640) {
                setTotalPerRow(2);  // 2 colonne per schermi piccoli
            } else {
                setTotalPerRow(1);  // 1 colonna per schermi extra piccoli
            }
        };

        updateTotalPerRow(); // Aggiorna subito al primo rendering
        window.addEventListener('resize', updateTotalPerRow);

        return () => {
            window.removeEventListener('resize', updateTotalPerRow);
        };
    }, []);

    return (
        /*GRIGLIA*/
        <Carousel
            className="w-full overflow-hidden sm:overflow-visible"
            opts={{
                align: "center",
                loop: false,
                dragFree: true,
            }}
        >
            <CarouselContent className="-ml-4">
                {sections.map((section, index) => (
                    <CarouselItem
                        key={section._id}
                        className="pl-4 basis-full sm:basis-1/4"
                    >
                        <div className="py-5">
                            <SectionCategory
                                key={section._id}
                                title={section.title}
                                slug={section.slug}
                                iconUrl={section.iconUrl}
                                categories={section.categories}
                                index={index}
                                totalPerRow={sections.length}  // Passa il numero dinamico di colonne
                            />
                        </div>
                    </CarouselItem>
                ))}
            </CarouselContent>
        </Carousel>
    );
};

export default FAQSection;
